export default class BursarsSelector {
  public static selectRequireReturn(state: ReduxState) {
    return state.bursar.requireReturn;
  }
}
